import { ModuleItemRoutingGroupExpression } from './module-item-routing-group-expression';

export interface ModuleItemRoutingGroup {
  id?: number;
  routingId?: number;
  operator?: string;
  routeToId?: number;
  routeToSpecial?: string;
  expressions?: ModuleItemRoutingGroupExpression[];
  createdAt?: string;
  updatedAt?: string;
}

export enum OtherwiseRouteToSpecial {
  NEXT_MODULE = 'next_module',
  END_OF_SURVEY = 'end_of_survey',
}

export enum OtherwiseRouteToSpecialIndex {
  NEXT_MODULE = 1000000,
  END_OF_SURVEY = 2000000,
}

export enum OtherwiseRouteToSpecialQuestion {
  NEXT_MODULE = 'Next module',
  END_OF_SURVEY = 'End of the survey',
}
